
/* START_TEMPLATE */
define('hbs!pricelist/templates/tabs',['hbs','handlebars','templates/helpers/stringContains'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, stack2, options, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "\r\n    <li role=\"presentation\"><a href=\"#discount2\" aria-controls=\"discount2\" role=\"tab\" data-toggle=\"tab\">Rabatter</a></li>\r\n";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\r\n    ";
  options = {hash:{},inverse:self.noop,fn:self.program(4, program4, data)};
  stack2 = ((stack1 = helpers.stringContains),stack1 ? stack1.call(depth0, depth0.tabs, "Additions", options) : helperMissing.call(depth0, "stringContains", depth0.tabs, "Additions", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n\r\n    ";
  options = {hash:{},inverse:self.noop,fn:self.program(6, program6, data)};
  stack2 = ((stack1 = helpers.stringContains),stack1 ? stack1.call(depth0, depth0.tabs, "Supplements", options) : helperMissing.call(depth0, "stringContains", depth0.tabs, "Supplements", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n\r\n    ";
  options = {hash:{},inverse:self.noop,fn:self.program(8, program8, data)};
  stack2 = ((stack1 = helpers.stringContains),stack1 ? stack1.call(depth0, depth0.tabs, "EditorialSchedule", options) : helperMissing.call(depth0, "stringContains", depth0.tabs, "EditorialSchedule", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n    <!--\r\n    ";
  options = {hash:{},inverse:self.noop,fn:self.program(10, program10, data)};
  stack2 = ((stack1 = helpers.stringContains),stack1 ? stack1.call(depth0, depth0.tabs, "ModuleMaps", options) : helperMissing.call(depth0, "stringContains", depth0.tabs, "ModuleMaps", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n    -->\r\n";
  return buffer;
  }
function program4(depth0,data) {
  
  
  return "\r\n        <li role=\"presentation\"><a href=\"#addition\" aria-controls=\"addition\" role=\"tab\" data-toggle=\"tab\">Pristillägg</a></li>\r\n    ";
  }

function program6(depth0,data) {
  
  
  return "\r\n        <li role=\"presentation\"><a href=\"#supplement\" aria-controls=\"supplement\" role=\"tab\" data-toggle=\"tab\">Annonsbilagepris</a></li>\r\n    ";
  }

function program8(depth0,data) {
  
  
  return "\r\n        <li role=\"presentation\"><a href=\"#editorialschedule\" aria-controls=\"editorialschedule\" role=\"tab\" data-toggle=\"tab\">Utgivningsplan</a></li>\r\n    ";
  }

function program10(depth0,data) {
  
  
  return "\r\n        <li role=\"presentation\"><a href=\"#modulemap\" aria-controls=\"modulemap\" role=\"tab\" data-toggle=\"tab\">Modulkarta</a></li>\r\n    ";
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\r\n    ";
  options = {hash:{},inverse:self.noop,fn:self.program(13, program13, data)};
  stack2 = ((stack1 = helpers.stringContains),stack1 ? stack1.call(depth0, depth0.tabs, "Information", options) : helperMissing.call(depth0, "stringContains", depth0.tabs, "Information", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n";
  return buffer;
  }
function program13(depth0,data) {
  
  
  return "\r\n        <li role=\"presentation\"><a href=\"#information\" aria-controls=\"information\" role=\"tab\" data-toggle=\"tab\">Upplysningar</a></li>\r\n    ";
  }

  buffer += "<li role=\"presentation\" class=\"active\"><a href=\"#annonspriser\" aria-controls=\"annonspriser\" role=\"tab\" data-toggle=\"tab\">Annonspriser</a></li>\r\n";
  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
  stack2 = ((stack1 = helpers.stringContains),stack1 ? stack1.call(depth0, depth0.tabs, "Discounts", options) : helperMissing.call(depth0, "stringContains", depth0.tabs, "Discounts", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n";
  stack2 = helpers['if'].call(depth0, depth0.isPrint, {hash:{},inverse:self.noop,fn:self.program(3, program3, data)});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n";
  stack2 = helpers['if'].call(depth0, depth0.hasMediaId, {hash:{},inverse:self.noop,fn:self.program(12, program12, data)});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n";
  return buffer;
  });
Handlebars.registerPartial('pricelist_templates_tabs', t);
return t;
});
/* END_TEMPLATE */
;
